import { ThemeProvider, useTheme } from '@mui/material';
import { Divider } from '@portals/core/src/components/Divider/Divider';
import { FinalContainer, FinalGridContainer, FinalGridItem } from '@portals/core/src/components/FinalGrid/FinalGrid';
import { RichTextRenderer } from '@portals/core/src/components/RichTextRenderer/RichTextRenderer';
import { Typography } from '@portals/core/src/components/Typography/Typography';
import type { Theme } from '@portals/core/src/themes/themes';
import React, { useMemo } from 'react';

import { LegalFooter as LegalFooterModel } from '../../../models/legal-footer';
import { getStyles } from './LegalFooter.styles';
import { LegalFooterLink } from './LegalFooterLink/LegalFooterLink';

interface Props {
  node: LegalFooterModel;
  createTheme: () => Theme;
}

export const LegalFooter: React.FunctionComponent<Props> = ({ node, createTheme }) => {
  const theme = useTheme();
  const styles = getStyles(theme);
  const columnWidth = 2;
  const id = `${node['__contentType'] || node['__component']}.${node.id}`;
  const footerTheme = useMemo(createTheme, [createTheme]);

  return (
    <FinalContainer disableGutters sx={styles.footerContainer} component="footer">
      <ThemeProvider theme={footerTheme}>
        <FinalContainer sx={styles.outerContainer}>
          {node.linkList?.items?.length ? (
            <FinalGridContainer id={id} sx={styles.innerContainer}>
              {node.linkList.items.map((item) => (
                <FinalGridItem
                  md={columnWidth}
                  lg={columnWidth}
                  data-selector={id}
                  component="ul"
                  margin={0}
                  sx={styles.gridItem}
                  key={`${item.__component}.${item.id}`}
                >
                  <LegalFooterLink node={item} />
                  <Divider sx={styles.divider} component="li" />
                </FinalGridItem>
              ))}
            </FinalGridContainer>
          ) : null}
          <Typography variant="body2" sx={styles.articleText}>
            <RichTextRenderer textColor="inherit" textVariant="body2" text={node.articleText}></RichTextRenderer>
          </Typography>
        </FinalContainer>
      </ThemeProvider>
    </FinalContainer>
  );
};
